import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import { connect } from "react-redux";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { Field, Form, Formik } from "formik";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
import DataGridFunction from "../../components/datagridComponent/datagrid";
import MuiButton from "../../components/muiButton/MuiButton";
import AutoCompleteMultiSelect from "../../components/autoCompleteComponent/AutoCompleteMultiSelect";
import { ShadowContainer } from "../../components/componentLayout/ComponentLayout";
import CampaignMappingAction from "../../stores/campaignMapping/CampaignMappingAction";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [
    InfluencerUserAction.REQUEST_INFLUENCER_USER,
    CampaignMappingAction.REQUEST_CAMPAIGN_MAPPING,
  ]),
  influencerUser: state.influencerUser.influencerUser.hits || [],
  campaignMapping: state.campaignMapping.campaignMapping.hits || [],
  pagination_user: state.campaignMapping.campaignMapping || {},
});

const AddInfluencerPermission = (props) => {
  //   let orgId = props.projectProps ? props.projectProps.organization_id : "";

  const [page_limit] = useState(10);

  function fetchInfluencer() {
    let params = {
      page_limit: "none",
      order_by: '[["created_on", "desc"]]',
    };
    props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
  }

  useEffect(() => {
    const param = { page_limit: "none" };
    fetchInfluencer(param);
  }, []);

  if (props.render) {
    let filter = [];

    filter.push(
      `["campaign_id.keyword","must","","term","${props.projectProps._id}"]`
    );

    let params_user = {
      order_by: '[["created_on", "desc"]]',
      filters: `[${filter}]`,
      page_number: 0,
      page_limit: 10,
    };

    props.dispatch(CampaignMappingAction.requestCampaignMapping(params_user));
    props.onCloseRender();
  }

  let userlist = [];

  if (props.influencerUser.hits) {
    props.influencerUser.hits.map((val) => {
      return userlist.push({
        influencer_id: val._id,
        influencer_name: val._source.influencer_name,
      });
    });
  }

  const handleInfluencerRemove = (row) => {
    props
      .dispatch(
        CampaignMappingAction.requestDeleteCampaignMapping(row.campaign_id)
      )
      .then(() => {
        let filter = [];

        filter.push(
          `["campaign_id.keyword","must","","term","${props.projectProps._id}"]`
        );

        let params_user = {
          order_by: '[["created_on", "desc"]]',
          filters: `[${filter}]`,
          page_number: 0,
          page_limit: 10,
        };

        props.dispatch(
          CampaignMappingAction.requestCampaignMapping(params_user)
        );
      });
  };

  // columns for datagrid
  const columns = [
    {
      field: "id",
      headerName: "SL NO",
      width: 120,
      resizable: false,
      flex: 2,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "campaign_id",
      headerName: "User ID",
      // width: 200,
      hide: true,
    },

    {
      field: "influencer_name",
      headerName: "Influencer Name",
      width: 320,
      flex: 6,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Remove",
      resizable: false,
      width: 160,
      flex: 4,
      cellClassName: "actions",
      renderCell: (params) => (
        <IconButton
          title="Remove"
          onClick={(event) => {
            event.ignore = true;
            handleInfluencerRemove(params.row);
          }}
          sx={{ border: "0" }}
        >
          <FontAwesomeIcon
            icon={faXmark}
            style={{ height: "20px", width: "20px", color: "#2a5e6c" }}
          ></FontAwesomeIcon>
        </IconButton>
      ),
    },

    // {
    //   field: "fullName",
    //   headerName: "Full Name",
    //   width: 320,
    //   flex: 10,
    // },
  ];

  function username_function(id) {
    let user_name = userlist.filter((val) => {
      return val.influencer_id === id && id;
    });

    return user_name[0] ? user_name[0].influencer_name : "";
  }

  // function fullName_function(id) {
  //   let user_name = userlist.filter((val) => {
  //     return val.user_id === id ? id : "";
  //   });
  //   return user_name[0] ? user_name[0].fullName : "";
  // }

  const rows = [];

  if (props.campaignMapping.hits) {
    props.campaignMapping.hits.map((item, index) => {
      return rows.push({
        id: item._id
          ? props.pagination_user.current_page_no * page_limit + ++index
          : "",
        campaign_id: item._id,
        influencer_name: username_function(
          item._source.influencer_id ? item._source.influencer_id : ""
        ),
      });
    });
  }

  const user_initial = {
    user: "",
    resource: "campaign",
    campaign_id: props.projectProps._id,
  };

  // pagination
  const handleChange = (event, value) => {
    // page_number=1&page_limit=10
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const filter = [];

    filter.push(
      `["campaign_id.keyword","must","","term","${props.projectProps._id}"]`
    );

    let params_user = {
      order_by: '[["created_on", "desc"]]',
      filters: `[${filter}]`,
      page_number: `${value}` - 1,
      page_limit: `${page_limit}`,
    };

    // props.dispatch(UserPermissionAction.requestUserPermission(params_user));
    props.reset();
  };

  const [loading, setLoading] = useState(false);

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
      <ShadowContainer>
        <DialogContent
        // className="bg-warning"
        >
          <DialogContentText
            sx={{ width: "100%" }}
            // className="bg-success"
          >
            <div className="text-center pb-2 ">
              <div className="row p-3">
                <div className="col-10 ">
                  <h3 className="dailogtext">
                    <b>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span className="span_first_letter">A</span>dd &nbsp;
                      <span className="span_first_letter">I</span>
                      nfluencer&nbsp; &nbsp;
                      {/* {props.projectProps.project_name} */}
                    </b>
                  </h3>
                </div>
                <div className="col-2 closebtn">
                  <i
                    title="Close"
                    className="fa fa-times-circle-o fa-2x"
                    style={{ size: "15px" }}
                    aria-hidden="true"
                    onClick={() => {
                      props.onClose();
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </DialogContentText>

          <Formik
            initialValues={user_initial}
            enableReinitialize={true}
            validateOnBlur={true}
            validateOnChange
            onSubmit={(values, formikHelpers) => {
              setLoading(true);
              if (values.user.influencer_id != null) {
                let obj = {
                  influencer_id: values.user.influencer_id,
                  resource: values.resource,
                  campaign_id: values.campaign_id,
                };

                let filter = [];
                filter.push(
                  `["campaign_id.keyword","must","","term","${values.campaign_id}"]`
                );
                let params_user = {
                  order_by: '[["created_on", "desc"]]',
                  filters: `[${filter}]`,
                  page_number: 0,
                  page_limit: 10,
                };
                props
                  .dispatch(
                    CampaignMappingAction.requestPostCampaignMapping(obj)
                  )
                  .then(() => {
                    props.dispatch(
                      CampaignMappingAction.requestCampaignMapping(params_user)
                    );
                    setLoading(false);
                    formikHelpers.resetForm();
                  });
              } else {
                alert("Please select a User");
                setLoading(false);
              }
              // values.user.user_name = "";
              // values.user.user_id = null;
            }}
          >
            {({
              errors,
              isValid,
              helperText,
              touched,
              dirty,
              handleChange,
              values,
            }) => (
              <Form>
                <Box
                  width="100%"
                  height="60px"
                  // className="bg-info"
                >
                  <Grid
                    item
                    container
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                      <Field
                        name="user"
                        size="small"
                        // Calling AutoCompleteMultiSelect Component
                        value={values.user ? values.user : null}
                        component={AutoCompleteMultiSelect}
                        options={userlist}
                        isOptionEqualToValue={(option, value) =>
                          //setting value property to custom value
                          option.influencer_name === value.influencer_name
                        }
                        getOptionLabel={(option) => option.influencer_name}
                        textFieldProps={{
                          margin: "normal",
                          variant: "outlined",
                          placeholder: "Users",
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={2}
                      sm={2}
                      xs={2}
                      textAlign="right"
                    >
                      <MuiButton
                        width="100%"
                        type="submit"
                        name="add"
                        loading={loading}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
          {navigator.onLine ? (
            <Box>
              <Grid
                display="flex"
                justifyContent="center"
                alignItems="center"
                container
                item
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
              >
                <Grid xl={12} lg={12} md={12} sm={12} xs={12}>
                  <LoadingIndicator
                    isActive={navigator.onLine ? props.isRequesting : false}
                  >
                    {!props.isRequesting && (
                      <DataGridFunction
                        columns={columns}
                        rows={rows}
                        rowHeight={60}
                        pagelength={props.pagination_user.total_page_no}
                        page={props.pagination_user.current_page_no}
                        handleChange={handleChange}
                        height="40vh"
                      />
                    )}
                  </LoadingIndicator>
                </Grid>
              </Grid>
            </Box>
          ) : (
            alert("No Internet Connection") || (
              <h3 style={{ textAlign: "center" }}>No Internet Connection</h3>
            )
          )}
          <Box></Box>
        </DialogContent>
      </ShadowContainer>
    </Dialog>
  );
};
export default connect(mapStateToProps)(AddInfluencerPermission);
